import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container clearFix" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h3 class=\"header-title\"><a href=\"/home\"><i class=\"logo\"></i></a><p><span title=\"生态环境部华南环境科学研究所\">生态环境部华南环境科学研究所</span><em title=\"全资企业 新技术转化运用平台\">全资企业 新技术转化运用平台</em></p></h3>", 1)
const _hoisted_4 = { class: "header-right" }
const _hoisted_5 = { class: "search-cont" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "华南所全资企业 科研新技术的转化应用平台", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "header-right-icon" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "nav-toggle-btn" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.keyword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
            class: "w-50 m-2",
            placeholder: "站内搜索"
          }, {
            suffix: _withCtx(() => [
              _createVNode(_component_el_icon, {
                class: "el-input__icon",
                onClick: _ctx.handleChange
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _hoisted_6
        ]),
        _hoisted_7
      ]),
      _hoisted_8
    ])
  ]))
}